  <div class="container-fluid sell_dash">
        <div class="wrapper">
            <div class="row">
              <app-sidemenu></app-sidemenu> 
              <section class="right">
                <app-sellheader></app-sellheader>
                <div class="right-middle row justify-content-center">
           <div class="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
          <div class="kt-subheader   kt-grid__item" id="kt_subheader">
                <div class="kt-container  kt-container--fluid ">
                   <div class="kt-subheader__main">
                      <h3 class="kt-subheader__title">
                         Offerings
                      </h3>
                      <span class="kt-subheader__separator kt-subheader__separator--v"></span>
                      <div class="kt-subheader__group" id="kt_subheader_search">
                         <span class="kt-subheader__desc" id="kt_subheader_total">
                         4 Total </span>
                      </div>

                   </div>
                   <div class="kt-subheader__toolbar">
                      <a routerLink="/sell" class="btn btn-label-brand">
                      Add Offering </a>
                   </div>
                </div>
             </div>
              <!--begin::Portlet-->
               <div class="col-md-12 col-12">
                 <div class="card-heading row justify-content-end">
                   <div class="col-md-4 col-1">
                     <img src="./assets/image/asset.png" width="25">
                   </div>
                   <div class="col-md-4 col-10">
                     <div class="title offset-lg-3">
                       <p>Edit Asset</p>
                     </div>
                   </div>
                   <div class="col-md-4 end col-1">
                     
                   </div>
                 </div>
               </div>
              <div class="kt-portlet kt-portlet--mobile dataoffering_background shadow-sm">
                 <div class="kt-portlet__body kt-portlet__body--fit">
                  <div class="kt-section__content">
                <table class="table">
                  <thead class="text-center">
                    <tr>
                      <th></th>
                      <th>Offering</th>
                      <th>Type</th>
                      <th>Creation Date</th>
                      <th>Marketplace</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody class="text-center">
                    <tr *ngFor="let post of posts | paginate: {itemsPerPage:5,currentPage: p}">
                      <td><a class="text-primary"><i class="fa fa-caret-right mt-2" style="font-size: 25px"></i></a></td>
                      <td>
                         <div class="row">
                            <div class="col-lg-4 col-xl-4 offset-lg-2 offset-xl-2">
                                <img src="./assets/image/offering.png" alt="photo" width="50">
                              </div>
                               <div class="col-xl-4 col-lg-4">
                                 <a class="row">{{post.offering}}</a>  
                                 <span class="row">123</span>
                               </div>
                          </div>
                      </td>
                      <td>{{post.type}}</td>
                      <td>{{post.create_date}}</td>
                      <td> 
                      <div class="text-center">
                                       <a routerLink='/userinfo' class="btn btn-success">
                                       <img src="./assets/image/icon/Sell.png" class="mr-2">Publish</a>
                                      </div>
                                  </td>
                                  <td> 
                                   <span>
                                     <a href="javascript:;" class="btn btn-sm btn-clean btn-icon btn-icon-md" title="View details">
                                             <i class="la la-leaf"></i>
                                           </a>                       
                                           <a href="javascript:;" class="btn btn-sm btn-clean btn-icon btn-icon-md" title="Edit details">
                                             <i class="la la-edit"></i>
                                           </a>
                                           <a href="javascript:;" class="btn btn-sm btn-clean btn-icon btn-icon-md" title="Delete">
                                             <i class="la la-trash"></i>
                                           </a>
                                         </span>
                                        </td>
                    </tr>
                  </tbody>
                </table>
                 <div class="mt-1 text-center kt-portlet__foot">
                          <pagination-controls (pageChange)="p = $event" class="mt-4"></pagination-controls>
                       </div>
              </div>
                 </div>
              </div>
              <!--end::Portlet-->
           </div>
                </div> 
             </section>   
            <!-- begin::Sticky Toolbar -->
          <app-stickytoolbar></app-stickytoolbar>
              <!-- end::Sticky Toolbar -->       
           </div>
        </div>
  </div>

